module.exports = __webpack_public_path__ + "img/20200625_085014.3e84fc51.jpg";